/**
 * Custom JavaScript overrides for Elastic Search integration.
 */

// This will remove attributes that are not needed
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            const elem = document.querySelector(selector);
            if (elem) {
                resolve(elem);
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Wait for the Elastic Search input form to load, then remove unneeded ARIA attributes
waitForElm('.sui-layout-header__inner form').then((elm) => {
    if (elm) {
        elm.removeAttribute('role');
        elm.removeAttribute('aria-expanded');
        elm.removeAttribute('aria-haspopup');
        elm.removeAttribute('aria-labelledby');
    }
});